module.exports = __webpack_public_path__ + "static/media/logo.ca6cc5cd.svg";